import { ResponsivePie } from '@nivo/pie'
import React, { useState, useEffect } from 'react'
import axios from 'axios'



export default function MyResponsivePie({ shop, start, end /* see data tab */ }) {

    const [shops, setShops] = useState([])

    useEffect(() => {

        if (shop === "all") {

            axios
                .get(`${process.env.REACT_APP_SERVER_URL}/api/dati/articles_no_interval?start=${start}&end=${end}`)
                .then((response) => {
                    console.log(response.data)
                    let prepared_data = response.data.per_negozio.buckets[0].articoli.buckets.map(bucket => {
                        return {
                            "id": bucket.key,
                            "value": bucket.doc_count,
                        }
                    });
                    setShops(prepared_data)
                })
                .catch((error) => {
                    console.log(error);
                })
        } else {
            axios
                .get(`${process.env.REACT_APP_SERVER_URL}/api/dati/articles_no_interval/${shop}?start=${start}&end=${end}`)
                .then((response) => {
                    let prepared_data = response.data.articoli.buckets[0].negozio.articoli.buckets.map(bucket => {
                        return {
                            "id": bucket.key,
                            "value": bucket.doc_count,
                        }
                    });
                    setShops(prepared_data)
                })
                .catch((error) => {
                    console.log(error);
                })
        }

    }, [start, end, shop]);


    if (shops) {

        return <ResponsivePie
            data={shops}
            margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={3}
            colors={{ scheme: 'nivo' }}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
            radialLabelsSkipAngle={10}
            radialLabelsTextColor="#333333"
            radialLabelsLinkColor={{ from: 'color' }}
            sliceLabelsSkipAngle={10}
            sliceLabelsTextColor="#333333"
        />
    }
}